import { Dialog, DialogContent, DialogProps, DialogTitle, IconButton } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import React, { FC } from 'react';

export interface SimpleDialogProps extends Omit<DialogProps, 'onClose'> {
    onClose: () => any;
    title?: string;
}

const SimpleDialog: FC<SimpleDialogProps> = (props) => {
    const classes = useStyles();
    const { onClose, title, ...restProps } = props;
    return (
        <Dialog onClose={onClose} classes={{ paper: classes.paper }} {...restProps} >
            <IconButton onClick={onClose} className={classes.closeButton} >
                <CloseIcon />
            </IconButton>
            <DialogTitle>{title || ''}</DialogTitle>
            <DialogContent className={classes.content} >
                {props.children}
            </DialogContent>
        </Dialog>
    )
}

const useStyles = makeStyles<Theme>((theme) => {
    return (createStyles({
        paper: {
            minWidth: 350
        },
        closeButton: {
            position: 'absolute',
            right: '8px',
            top: '8px'
        },
        content: {
            paddingBottom: 24
        }
    }))
})

export default SimpleDialog